import style from "./style.scss";
import Link from "../link";

import brandMap from "../../../data/brands.json";
import tagMap from "../../../data/tags.json";

/**
 * @param {Object} props
 * @param {string[] | Object.<string, string[]>} props.brands
 *   - Array:  List of brand slugs
 *   - Object: brand → list of tag slugs (nested mode)
 *     {
 *       ecoflow: ["power-stations", "alternator-chargers"],
 *       velit: ["heating"]
 *     }
 * @param {string[]} [props.tags]
 *   - List of tag slugs
 */
const Tags = ({ brands, tags = [] }) => {
  // Detect whether `brands` is a nested structure:
  //  array → simple brand list
  //  object → brand → tag relationships
  const isNested =
    brands && typeof brands === "object" && !Array.isArray(brands);

  // Extract brand slugs
  const brandSlugs = isNested
    ? Object.keys(brands)
    : Array.isArray(brands)
    ? brands
    : [];

  // Build brand links
  const brandItems = brandSlugs.map((slug) => ({
    label: brandMap[slug] || slug,
    link: `/?brand=${slug}`,
  }));

  // Build brand tag links
  const nestedItems = isNested
    ? Object.entries(brands).flatMap(([brandSlug, tagList]) =>
        tagList.map((tagSlug) => ({
          label: tagMap[tagSlug] || tagSlug,
          link: `/?tags=${tagSlug}`,
          brandSlug,
        }))
      )
    : [];

  // Build standalone tag links
  const tagItems = tags.map((slug) => ({
    label: tagMap[slug] || slug,
    link: `/?tags=${slug}`,
  }));

  let items;

  if (isNested) {
    // Nested mode: [tags], [brand: [brand tags]]
    items = [
      ...tagItems,
      ...brandSlugs.flatMap((brandSlug) => [
        {
          label: brandMap[brandSlug] || brandSlug,
          link: `/?brand=${brandSlug}`,
        },

        ...nestedItems.filter((i) => i.brandSlug === brandSlug), // nested tags for brand
      ]),
    ];
  } else {
    // Flat mode: [brands], [tags]
    items = [...brandItems, ...tagItems];
  }

  if (!items.length) {
    return null;
  }

  return (
    <nav aria-label="Tags" class={style.wrapper}>
      <strong class={style.title}>Tags:</strong>
      <ul class={style.tags}>
        {items.map((item) => (
          <li key={item.link} class={style.tag}>
            <Link href={item.link}>{item.label}</Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Tags;
